import type { HandshakeFiltersState } from "./HandshakeFilters";

export const defaultFilters: HandshakeFiltersState = {
  statuses: [],
  channels: [],
  dateFrom: "",
  dateTo: "",
  customerName: "",
  sellerUserId: "",
};

export function countHandshakeActiveFilters(
  applied: HandshakeFiltersState,
  options?: {
    showCustomerNameFilter?: boolean;
    showSellerFilter?: boolean;
  },
): number {
  const showCustomerNameFilter = options?.showCustomerNameFilter ?? true;
  const showSellerFilter = options?.showSellerFilter ?? false;
  let count = 0;
  if (applied.statuses.length > 0) count++;
  if (applied.channels.length > 0) count++;
  if (applied.dateFrom !== "" || applied.dateTo !== "") count++;
  if (showCustomerNameFilter && applied.customerName !== "") count++;
  if (showSellerFilter && applied.sellerUserId !== "") count++;
  return count;
}
